<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Apparato Respiratorio" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Forma Torace:</label>
                            <span v-if="isReadOnly">{{ jsonDataApparatoRespiratorio.formaTorace }}</span>
                            <b-form-textarea v-else v-model="jsonDataApparatoRespiratorio.formaTorace" :readonly="isReadOnly" max-rows="4" rows="1"> </b-form-textarea>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Espansibilità polmonare Bilaterale:</label>
                            <span v-if="isReadOnly">{{ jsonDataApparatoRespiratorio.espansibilitaPolmonareBilaterale }}</span>
                            <b-form-textarea v-else v-model="jsonDataApparatoRespiratorio.espansibilitaPolmonareBilaterale" :readonly="isReadOnly" max-rows="4" rows="1"> </b-form-textarea>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">FVT:</label>
                            <span v-if="isReadOnly">{{ jsonDataApparatoRespiratorio.fvt }}</span>
                            <b-form-textarea v-else v-model="jsonDataApparatoRespiratorio.fvt" :readonly="isReadOnly" max-rows="4" rows="1"> </b-form-textarea>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Murmure Vescicolare:</label>
                            <span v-if="isReadOnly">{{ jsonDataApparatoRespiratorio.murmureVescicolari }}</span>
                            <b-form-textarea v-else v-model="jsonDataApparatoRespiratorio.murmureVescicolari" :readonly="isReadOnly" max-rows="4" rows="1"> </b-form-textarea>
                        </b-col>
                    </b-row>
                    <div class="d-flex justify-content-end">
                        <b-button v-if="!isReadOnly && jsonDataApparatoRespiratorio.id" @click="onSaveApparatoRespiratorio"  variant="outline-success">Salva</b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        idAccettazione: {
            type: String,
        },
        jsonDataApparatoRespiratorio: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    formaTorace: "",
                    espansibilitaPolmonareBilaterale: "",
                    fvt: "",
                    murmureVescicolari: "",
                };
            },
        },
    },
    mixins: [UtilityMixin],
    watch: {
        jsonDataApparatoRespiratorio: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    data() {
        return {
            pathResourceSchedaRelazioneSanitariaApparatoRespiratorio: "/rsaschedarelazionesanitariaapparatorespiratorio",
        };
    },
    methods: {
        loadSchedaRelazioneSanitariaApparatoRespiratorio() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaRelazioneSanitariaApparatoRespiratorio + "/accettazione/" + me.idAccettazione, {}, me.resultResponseSchedaRelazioneSanitariaApparatoRespiratorioSuccess, me.resultResponseSchedaRelazioneSanitariaApparatoRespiratorioError);
        },

        resultResponseSchedaRelazioneSanitariaApparatoRespiratorioSuccess(response) {
            let me = this;
            me.jsonDataApparatoRespiratorio = response.data.data;
        },

        resultResponseSchedaRelazioneSanitariaApparatoRespiratorioError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                me.resetForm();
            }
        },

        resetForm() {
            let me = this;
            me.jsonDataApparatoRespiratorio = {
                id: null,
                idAccettazione: this.idAccettazione,
                formaTorace: "",
                espansibilitaPolmonareBilaterale: "",
                fvt: "",
                murmureVescicolari: "",
            };
        },

        onSaveApparatoRespiratorio() {
            let me = this;
            me.jsonDataApparatoRespiratorio.idAccettazione = me.idAccettazione;
            if (!me.jsonDataApparatoRespiratorio.idAccettazione) {
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResourceSchedaRelazioneSanitariaApparatoRespiratorio, me.jsonDataApparatoRespiratorio, me.saveSchedaRelazioneSanitariaApparatoRespiratorioSuccessResponse, me.saveSchedaRelazioneSanitariaApparatoRespiratorioErrorResponse);
        },
        saveSchedaRelazioneSanitariaApparatoRespiratorioSuccessResponse() {
            let me = this;
            me.$bvToast.toast("Apparato respiratorio salvato con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
            me.$parent.loadData();
        },
        saveSchedaRelazioneSanitariaApparatoRespiratorioErrorResponse() {
            console.error("Errore nel salvataggio dell'apparato respiratorio:");
        },
    },
};
</script>
